<template>
  <div>
    <v-container>
      <h3 class="d-block text-center" style="color: #434343; padding: 8px">
      </h3>
      <v-form ref="formCorpInfo">
        <v-row class="ma-0">
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Corporate Name
              <span class="red--text"><strong>*</strong></span></label
            >
            <v-text-field
              v-model="corporate_information.corporate_name"
              color="#434343"
              :rules="TextRules"
              maxlength="51"
              placeholder="Enter Corparate Name"
              outlined
              dense
              name="corporate_name"
              id="corporate_name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Registration Number
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              v-model="corporate_information.registration_number"
              color="#434343"
              outlined
              placeholder="Enter Registeration Number"
              maxlength="51"
              :rules="TextRules"
              label=""
              dense
              name="registeration-number"
              id="registeration_number"
            ></v-text-field>
            <p v-if="duplicateReg" class="caption red--text mt-n7 text-right">Already exist *</p>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Incorporation Date
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="corporate_information.incorporation_date"
                  :rules="[(v) => !!v || 'Required']"
                  label=""
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  placeholder="Enter Incorporation Date"
                  v-bind="attrs"
                  v-on="on"
                  name="incorporation_date"
                  id="incorporation_date"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="corporate_information.incorporation_date"
                @input="menu = false"
                :max="todayDate"
              ></v-date-picker>
            </v-menu>
            <!-- <v-text-field
                    v-model="incorporation_date"
                    color="#434343"
                    :rules="[v => !!v || 'Required']"
                    outlined
                    placeholder
                    maxlength="51"
                    label="Incorporation Date"
                    type="date"
                    dense
                    name="incorporation_date"
                    id="incorporation_date"
                  ></v-text-field> -->
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Registered Street Address
              <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="TextRules"
              v-model="corporate_information.registered_address"
              color="#434343"
              outlined
              placeholder="Enter Registered Street Address"
              maxlength="51"
              label=""
              dense
              name="registered_street_address"
              id="registered_street_address"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >City <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="TextRules"
              v-model="corporate_information.city"
              color="#434343"
              outlined
              placeholder="Enter City"
              maxlength="51"
              label=""
              dense
              name="corporate_city"
              id="corporate_city"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Country <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="TextRules"
              v-model="corporate_information.country"
              color="#434343"
              outlined
              placeholder="Enter Country"
              maxlength="51"
              label=""
              dense
              name="corporate_country"
              id="corporate_country"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Postal Code
              <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="TextRules"
              v-model="corporate_information.postal_code"
              color="#434343"
              outlined
              placeholder="Enter Postal Code"
              maxlength="51"
              label=""
              dense
              name="corporate_postal_code"
              id="corporate_postal_code"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >VAT Number
              <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="TextRules"
              v-model="corporate_information.VAT_number"
              color="#434343"
              outlined
              placeholder="Enter VAT Number"
              maxlength="51"
              label=""
              dense
              type="number"
              name="corporate_vat_number"
              id="corporate_vat_number"
            ></v-text-field>
             <p v-if="duplicateVat" class="caption red--text mt-n7 text-right">Already exist *</p>
            <!-- <p v-if="duplicateVat" class="caption red--text mt-n7">Already exist *</p> -->
          </v-col>
        </v-row>
      </v-form>
      <v-btn
       
        @click="updateCorporateInfoSection()"
        class="float-end mb-2 next-btn appBlue white--black"
        >Next</v-btn
      >
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      corporate_information: {
        corporate_name: "",
        registration_number: "",
        incorporation_date: "",
        registered_address: "",
        city: "",
        country: "",
        postal_code: "",
        VAT_number: "",
        business_address: "",
        business_city: "",
        business_country: "",
        business_postal_code: "",
      },
      duplicateVat: false,
      duplicateReg: false,
      todayDate:"",
      TextRules: [(v) => !!v || "Required"],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      menu: false,
    };
  },
  mounted() {
    let today = new Date();
    this.todayDate = today.toISOString().slice(0, 10);
    // this.TextRules.push((v) => v.length <= 50 || "Max 50 characters");
    this.getCorporateInfo();

  },
//   watch:{
//     corporate_information:{
//         deep : true,
//         handler(newVal){
//             console.log(newVal.registration_number);
//             if(newVal.registration_number){
//                // check duplicate
//                     axios.post("/validateFields",
//                     {
//                       registration_number: newVal.registration_number,
//                       VAT_number: newVal.VAT_number,
//                     },
//                         {
//                             headers: {
//                             Authorization: "Bearer " + localStorage.getItem("token"),
//                             },
//                         }
//                         )
//                         .then((res) => {
//                            this.duplicateReg=false;
//                         })
//                         .catch((err) => {
//                         console.log(err.response.data);
//                          if(err.response.status==422){
//                                 this.duplicateReg=true;
                             
//                            } 
//                            else{
//                                this.duplicateReg=false;
//                            }
//                         });
//             }
            

//         }
//     }
//   },
  computed: {
    ...mapGetters(["getFormId", "getUserId", "getCorporateID", "getCorporateInfoError"]),
  },
  methods: {
      getCorporateInfo(){
          axios
      .post(
        "/corporateForm",
        {
          form_id: this.getFormId,
          user_id: this.getUserId
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        // console.log(res.data.corporateForm, "mounted");
        (this.corporate_information.corporate_name =
          res.data.corporateForm.corporate_name == null
            ? ""
            : res.data.corporateForm.corporate_name),
          (this.corporate_information.registration_number =
            res.data.corporateForm.registration_number == null
              ? ""
              : res.data.corporateForm.registration_number),
          (this.corporate_information.incorporation_date =
            res.data.corporateForm.incorporation_date == null
              ? ""
              : res.data.corporateForm.incorporation_date),
          (this.corporate_information.registered_address =
            res.data.corporateForm.registered_address == null
              ? ""
              : res.data.corporateForm.registered_address),
          (this.corporate_information.city =
            res.data.corporateForm.city == null
              ? ""
              : res.data.corporateForm.city),
          (this.corporate_information.country =
            res.data.corporateForm.country == null
              ? ""
              : res.data.corporateForm.country),
          (this.corporate_information.postal_code =
            res.data.corporateForm.postal_code == null
              ? ""
              : res.data.corporateForm.postal_code),
          (this.corporate_information.VAT_number =
            res.data.corporateForm.VAT_number == null
              ? ""
              : res.data.corporateForm.VAT_number),
          (this.corporate_information.business_address =
            res.data.corporateForm.business_address == null
              ? ""
              : res.data.corporateForm.business_address),
          (this.corporate_information.business_city =
            res.data.corporateForm.business_city == null
              ? ""
              : res.data.corporateForm.business_city),
          (this.corporate_information.business_country =
            res.data.corporateForm.business_country == null
              ? ""
              : res.data.corporateForm.business_country),
          (this.corporate_information.business_postal_code =
            res.data.corporateForm.business_postal_code == null
              ? ""
              : res.data.corporateForm.business_postal_code);
        // this.corporate_information = res.data.corporateForm;
      })
      .catch(err => {
        console.log(err.response, "err");
      });

      },
    updateCorporateInfoSection() {
      // this.corporateStepper = 2;
      // this is validating fields of corporate info stepper
      if (!this.$refs.formCorpInfo.validate()) {
        this.$store.dispatch("updateCorporateInfoError", true);
        this.corporateInfoError = !true;
      } else {
        this.$store.dispatch("updateCorporateInfoError", !true);
        this.corporateInfoError = true;
      }

      // Update Corporate Information
      axios
        .post(
          "/createCorporateInformation",
          {
            form_id: this.getFormId,
            user_id: this.getUserId,
            corporate_form: this.corporate_information,
            corporate_id: this.getCorporateID,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
         
            if(res.status==201){
               this.duplicateReg=false;
               this.duplicateVat = false;
            }
            // if(res.status==422){
            //     // console.log("hi")
            //     this.updateIndex(1);
            // }
          // this.$store.dispatch("corporateId", res.data.corporate_id);
          // console.log(res.data, "added");
        })
        .catch((err) => {
          if(err.response.status==422){
            //true means unique number and false means duplicate entry of reg / vat number
             this.$store.dispatch("updateCorporateDuplicate", true);
             if(err.response.data.reg_number==true &&err.response.data.vat_number==true){
               this.duplicateReg=true;
               this.duplicateVat = true;


             }
             else if(err.response.data.reg_number==true){
                this.duplicateReg=true;
               this.duplicateVat = false;
             }
             else if(err.response.data.vat_number==true){
               this.duplicateVat = true;
               this.duplicateReg=false;
             }
          }
          console.log(err.response.data);
        });

      this.corporateStepper = 2;
      this.updateIndex(2);
    },
    updateIndex(index) {
        this.$store.dispatch("updateIndex", index);
    },
  },
};
</script>

<style scope>

</style>